import api from '../..'

const getSurveyBlock = (blockId: number) => {
  return api.get(`block_survey/block_instances/${blockId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }) => {
      const {
        blockInstanceable: { id, lessonId, mandatory, description, blockInstanceableType, name, order },
        questionsForms,
      } = attributes
      return { id, lessonId, mandatory, type: blockInstanceableType, name, description, order, questionsForms }
    }
  )
}

export default getSurveyBlock
